import { Component, Inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BadgeRepo } from 'src/app/repositories/badge-repo';
import { StationsRepo } from 'src/app/repositories/stations/repo/station-repo';
import { SubscriptionRepo } from 'src/app/repositories/subscription-repo';
import { AuthSupport, Station, Subscription } from 'src/swagger-gen/web-secured/models';

@Component({
    selector: 'app-modal-delete-badge',
    templateUrl: './modal-delete-badge.component.html',
    styleUrls: ['./modal-delete-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalDeleteBadgeComponent implements OnDestroy {
  loading = false;
  deleteSuccess: any;
  deleteError: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public badge: AuthSupport,
    private badgeRepo: BadgeRepo,
    private translate: TranslateService,
    private router: Router
  ) {}

  deleteBadge() {
    this.loading = true;
    this.badgeRepo
      .deleteBadge(this.badge.uid).toPromise()
        .then((response: any) => {
          this.loading = false;
          this.deleteSuccess = this.translate.instant('badges.delete.success');
        })
        .catch((error: any) => {
          this.loading = false;
          this.deleteError = this.translate.instant('badges.delete.error');
        });
  }

  ngOnDestroy() {
  }
}
